export { HeritageLoaderComponent } from './lib/heritage-loader/heritage-loader.component';
export { HeritageFormComponent } from './lib/heritage-form/heritage-form.component';
export { HeritageFormOptionsService } from './lib/heritage-form/heritage-form-options.service';
export { HeritageFormReshapeService } from './lib/heritage-form/heritage-form-reshape.service';

export * from './lib/heritage.module';
